import { Box, Stack } from "@mui/material";
import { Custom, Field } from "components";
import { useApp, useTheme } from "contexts";
import { Validations } from "helpers";
import { useShare } from "hooks";
import { IUser } from "interfaces";
import { Enums } from "utils";

// icons
import { LinkRounded, SendRounded } from "@mui/icons-material";

type Props = {
  id: string;
  open: boolean;
  onClose: () => void;
  participants: IUser[];
  type?: Enums.EnumShare;
};

export const Share = ({
  id,
  open,
  onClose,
  participants,
  type = Enums.EnumShare.Invite,
}: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();
  const { emails, handleOnChange, handleOnCopy, handleOnSubmit, users } =
    useShare(id, participants, type, onClose);

  return (
    <Custom.Modal
      open={open}
      onClose={onClose}
      title={t.component.popup.share.title}
    >
      <Box>
        <Stack spacing={theme.spacing.md}>
          <Custom.Typography
            align="center"
            size={theme.font.xs}
            weight={theme.font.bold}
          >
            {t.component.popup.share.headline}
          </Custom.Typography>
          <Custom.Typography
            align="center"
            size={theme.font.xs}
            weight={theme.font.normal}
          >
            {t.component.popup.share.description}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Field.DynamicAutocomplete
            avatar
            options={users}
            value={emails}
            onValidate={Validations.isEmail}
            onChange={handleOnChange}
          />
          <Custom.Button
            variant="outlined"
            endIcon={<SendRounded />}
            color={theme.color.accent.color}
            onClick={handleOnSubmit}
          >
            {t.action.send_invite}
          </Custom.Button>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Custom.Button
          fullWidth
          variant="outlined"
          endIcon={<LinkRounded />}
          color={theme.color.accent.color}
          onClick={handleOnCopy}
        >
          {t.action.copy_link}
        </Custom.Button>
      </Box>
    </Custom.Modal>
  );
};
